const getDataProps = props =>
  Object.entries(props)
    .filter(([prop]) => prop.startsWith('data-'))
    .reduce((acc, [prop, value]) => ({ ...acc, [prop]: value }), {});

export default getDataProps;
